import utilManager from '../../util';
import Param from './param';
import effectManager from './effect';

let util = new utilManager();
let effect = new effectManager();

export default class mainvisualManager {
    constructor() {

        this.w = 0;

        /* 共通パラメータ読み込み */
        this.param = new Param();

        //dom
        this.$scene;

        //設定
        this.conf = {
            max : 3,
            pause: 240,
        }


        //ステータス管理
        this.status = {
            startFlg:false,
            current : 0,
            prevCurrent:3,
            time : 0,
            prevOrder:[], //手前の順番指定を保存
            order:[],
            progress : 0,
            deviceOrientation:"",
            changeFlg : false,//切り替えを監視
        }

        this.$seekbarCurrent;

        this.time = 0;
        this.FPS_60_SEC = 1000 / 60;

    }
    init(){

        this.resize();

        this.$scene = $("#l-kv-bg-img .scene");
        this.$seekbarCurrent = $("#l-kv-seek-line-now");

        effect.splitText($("#l-kv-seek .sports li,#l-kv-info-content .category-name"));
        effect.setSvg($("#l-kv-scrolldown-icon"));
        TweenMax.set($("#l-kv-copy .js__sp-show svg"),{x:400,opacity:0});
        TweenMax.set($("#l-kv-info-content .js__sp-show"),{opacity:0});
        TweenMax.set($("#l-kv-scrolldown"),{opacity:0,x:200});



        this.render();
        this.setOrderClass();
        this.setOrder("set");


        /* 初回表示の時だけアニメーションさせるもの */
        TweenMax.set(this.$scene.eq(1).children(".scene-cover"), {
            x : -110+"%"
        });
        TweenMax.to(this.$seekbarCurrent,0.6,{x:0+"%",onComplete:()=>{
                TweenMax.to($("#l-kv-cover"),1.8, {
                    x:-110+"%",
                    ease:Expo.easeOut,
                });
                TweenMax.to(this.$seekbarCurrent,0.6,{x:-110+"%"});
                TweenMax.to(this.$seekbarCurrent.children(),0.6,{backgroundColor:"#fff"});

            }});

        setTimeout(()=> {
            // this.update();
            TweenMax.staggerTo($("#l-kv-copy .js__sp-show svg"),2.2,{
                x:0,
                opacity:1,
                ease:Expo.easeOut,
            },0.1,()=>{


            });
            setTimeout(()=> {
                this.status.startFlg = true;
                if(!Useragnt.ie) TweenMax.to(this.$scene.eq(0).children(".scene-img"),6, {
                    scale: 1.05,
                });

                TweenMax.to($("#l-header"),0.6,{y:0});

                effect.copyIn($("#l-kv-info-content .category-name.no1 >* >*"),20,1.2);
                effect.copyIn([$("#l-kv-info-content .js__sp-show"),$("#l-kv-scrolldown-text >* >*")],20,1.2);
                this.seekbarMot();
                this.scrolldownMotion();
            },1e3);
        },1e3);
        // _this.update();
        // _this.loop();

        let _deviceOrientation;

        window.addEventListener('resize', () => {
            this.resize();

        }, false);


    }
    seekbarMot(){
        TweenMax.to(this.$seekbarCurrent,0.6,{x:-100+"%",onComplete:()=>{
                // TweenMax.to(this.$seekbarCurrent,3.5,{x:0+"%"});
            }});
    }

    infoTextChange(){

        effect.copyOut2(
            $("#l-kv-info-content .number-current-change_"+(this.status.prevCurrent+1)),
            20,0.9);
        effect.copyOut2(
            $("#l-kv-info-content .category-name.no"+(this.status.prevCurrent+1)+" >* >*"),
            20,0.9);
        setTimeout(()=>{
            effect.copyIn(
                $("#l-kv-info-content .number-current-change_"+(this.status.current+1)),
                40,1.3);
            effect.copyIn(
                $("#l-kv-info-content .category-name.no"+(this.status.current+1)+" >* >*"),
                40,1.3);
        },1e3);
    }

    scrolldownMotion(){


        TweenMax.to($("#l-kv-scrolldown"),1.6,
            {
                x:0,
                opacity:1,
                ease:Power3.easeOut,
                onComplete:function () {
                    // effect.copyIn($("#l-kv-scrolldown-text >* >*"),20,1.68);

                    TweenMax.to( $("#l-kv-scrolldown-icon polyline"),0.48,{
                        drawSVG: "100%",
                        repeat:-1,
                        yoyo:true,
                        // onRepeat:_onRepeat,
                        repeatDelay:1
                    });
                }
            });


    }

    loop(){
    }

    update(){

        if(this.status.current>=0){
            this.status.prevCurrent = this.status.current;
            this.status.current = this.conf.max > this.status.current ? this.status.current+1 : 0;
            let _$ps = this.$scene.eq(this.status.prevCurrent);


            this.infoTextChange();

            // 背景にアニメーション　表示中のイメージを消す
            this.seekbarMot();
            TweenMax.to(_$ps,1.5,{
                x : -110 + "%",
                opacity:0,
                ease: Power2.easeOut,
            })
            TweenMax.to(_$ps.children(".scene-cover"),1.5, {
                x: 0 + "%",
                ease: Power2.easeOut,
            });
            TweenMax.to(_$ps.children(".scene-img"),1.5,{
                x : 100 + "%",
                scale: !Useragnt.ie ? 1.05 : 1,
                ease: Power2.easeOut,
                onComplete:()=>{
                    TweenMax.set(_$ps.children(),{
                        x:0+"%",
                        scale:1
                    })
                    TweenMax.set(_$ps,{
                        x:4.5*3+"%",
                        opacity:1
                    })

                    _$ps.removeClass("is-current");
                    this.setOrderClass();

                }
            })
            this.setOrder();
            // 背景にアニメーション　次のイメージを表示
            TweenMax.to(this.$scene.eq(this.status.current),1.5, {
                x: 0 + "%",
                opacity:1,
                ease: Power2.easeOut,
                onComplete:()=>{
                    this.status.changeFlg = false;
                    TweenMax.to(this.$scene.eq(this.status.current).children(".scene-img"),6, {
                        scale: !Useragnt.ie ? 1.05 : 1,
                    });
                }
            });
            TweenMax.fromTo(this.$scene.eq(this.status.current).children(".scene-cover"),1,{
                x : 100 + "%"
            },{
                x: -110 + "%",
                ease: Expo.easeOut,
            });

        }


        this.$scene.eq(this.status.current).addClass("is-current");





        // if(this.current<this.MAX){
        //     this.current++;
        // }else{
        //     this.current = 0;
        // }
    }

    setOrderClass(){


        for(let i=0; i<=this.conf.max; i++){
            if(this.status.prevOrder.length>0){

                for(let j=1; j<=4; j++){
                    this.$scene.eq(i).removeClass("is-order"+j);
                }
                if(this.status.order[i]==3){
                    TweenMax.set(this.$scene.eq(i),{
                        x : 4.5 * 3 + "%",
                        // opacity:0.5,
                    })
                }
                // let _i = i-this.status.current<0?(i-this.status.current)*-1:i-this.status.current;
                // _i = this.status.current==1&&i==0?this.conf.max:this.status.current==2&&i==1?this.conf.max:this.status.current==3&&i==0?1:this.status.current==3&&i==2?3:_i;

                this.$scene.eq(i).addClass("is-order"+(this.status.order[i]+1));
            }
        }
    }
    setOrder(type){
        // let _p = [];
        for(let i=0; i<=this.conf.max; i++){

            this.status.order[i] = i-this.status.current<0?(i-this.status.current)*-1:i-this.status.current;
            this.status.order[i] = this.status.current==1&&i==0?this.conf.max:this.status.current==2&&i==1?this.conf.max:this.status.current==3&&i==0?1:this.status.current==3&&i==2?3:this.status.order[i];

            //     let _i = i-this.status.current<0?(i-this.status.current)*-1:i-this.status.current;
            // _i = this.status.current==1&&i==0?this.conf.max:this.status.current==2&&i==1?this.conf.max:this.status.current==3&&i==0?1:this.status.current==3&&i==2?3:_i;


            if(type=="set"){
                TweenMax.set(this.$scene.eq(i),{
                    x : 4.5 * this.status.order[i] + "%",
                    // opacity:i<=1?1:0.5,
                })
            }else{


                if(i!=this.status.current){
                    if(this.status.order[i]==3){
                        // TweenMax.set(this.$scene.eq(i),{
                        //     x : 4.5 * 3 + "%",
                        //     // opacity:0.5,
                        // })
                    }else{
                        TweenMax.to(this.$scene.eq(i),0.8,{
                            x : 4.5 * this.status.order[i] + "%",
                            // opacity:0.5,
                            // delay : Math.floor(0.1*(this.conf.max-this.status.order[i])*10)/10,
                            ease: Power2.easeOut
                            // ease: Back.easeOut.config(2)
                            // delay:1
                        })
                    }

                    if(this.status.order[i]==1){

                        TweenMax.to(this.$scene.eq(i),2, {
                            opacity:1,
                            ease: Power1.easeOut,
                        });
                        TweenMax.to(this.$scene.eq(i).children(".scene-cover"),2, {
                            x: -50 + "%",
                            ease: Power1.easeOut,
                        });

                    }

                }
            }



            // _p[i] = this.status.order[i];
        }
        this.status.prevOrder=this.status.order;
    }
    render(){
        if(!requestAnimationFrame){
            setTimeout(()=>this.render,1000/60);
        }else{
            requestAnimationFrame(this.render.bind(this));
        }

        if(!this.status.startFlg||this.status.changeFlg) return;

        // console.log(this.updateTimeRatio())

        this.status.time += 1;

        let _p = Math.floor(this.status.time/this.conf.pause*100)/100;
        this.status.progress += 0.2 * (_p - this.status.progress);
        TweenLite.set(this.$seekbarCurrent,{x:-100 + 105*this.status.progress + "%"});

        // if(this.status.time>=this.conf.pause){
        //     this.status.time = 0;
        //     this.update();
        // }
        if(this.status.time>=this.conf.pause){
            this.status.time = 0;
            this.status.progress = 0;
            this.status.changeFlg = true;
            this.update();
        }



    }

    resize(){


        if(this.w==window.innerWidth&&!Useragnt.pc) return;

        this.w = window.innerWidth;

        $("#l-kv").css({"height":window.innerHeight})


        if(Useragnt.tablet){
            if(window.innerWidth<window.innerHeight){

                if(this.status.deviceOrientation=="land") return;
                this.status.deviceOrientation = "land";
                $("html").addClass("is-land");
                $("html").removeClass("is-port");

            }else{

                if(this.status.deviceOrientation=="port") return;
                this.status.deviceOrientation = "port";
                $("html").removeClass("is-land");
                $("html").addClass("is-port");

            }
        }


    }

    updateTimeRatio() {
        let _lastTime = this.time;
        let _timeRatio = 1;
        if(_lastTime > 0) {
            let _dTime = new Date().getTime() - _lastTime;
            _timeRatio = _dTime / this.FPS_60_SEC;
        }
        this.time = new Date().getTime();

        return _timeRatio;
    }

}